import { Button } from "antd";
import { ReactNode } from "react";

export default function PrimaryButton({
  children,
  className,
  ...rest
}: {
  children: ReactNode;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Button
      className={`bg-webPrimary !text-white border-0 ring-0 ${className}`}
      {...rest}
    >
      {children}
    </Button>
  );
}
